import React, { useState, useEffect } from 'react'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
import './ReviewImages.css'
import Skeleton from 'react-loading-skeleton'
import ImageGridModal from './ImageGridModal'
import { handleHeicImageType } from 'components/utils/handleHeicImageTypes'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})

const ReviewImages = (props) => {
  const [imagesLoading, setImagesLoading] = useState(true)
  const [showGridModal, setShowGridModal] = useState(false)
  const [reviewImages, setReviewImages] = useState([])

  const buildImageClassName1 = (imageIndex, imageLength) => {
    if (imageIndex === 0) {
      return 'review-grid-col-2 review-grid-row-2'
    } else if (imageLength - 1 === imageIndex) {
      return 'review-grid-image last-image-review'
    } else {
      return 'review-grid-image image-index-' + imageIndex
    }
  }

  const buildImageClassName2 = (imageIndex, imageLength) => {
    if (imageLength === 1) {
      return 'review-grid-col-1 review-grid-row-1 image-index-0'
    } else if (imageLength === 2) {
      if (props.isMobile) {
        return 'review-grid-col-1 review-grid-row-1-images'
      } else {
        return 'review-grid-col-2 review-grid-row-2'
      }
    } else if (imageLength === 3) {
      if (imageIndex === 0) {
        return 'review-grid-col-2 review-grid-row-2'
      } else {
        return 'review-grid-col-2'
      }
    } else {
      if (imageIndex === 0) {
        return 'review-grid-col-2 review-grid-row-2'
      } else if (imageIndex === getMaxIndexNumber()) {
        if (imageLength > getMaxImgNumber()) {
          return (
            'review-grid-image review-grid-col-1 image-index-' +
            imageIndex +
            ' last-image-review has-more-images'
          )
        } else {
          return (
            'review-grid-image review-grid-col-1 image-index-' +
            imageIndex +
            ' last-image-review'
          )
        }
      } else {
        if (props.isMobile) {
          return 'review-grid-image review-grid-col-1'
        } else {
          return 'review-grid-image review-grid-col-1 image-index-' + imageIndex
        }
      }
    }
  }

  const getMaxImgNumber = () => {
    if (props.isMobile) {
      return 4
    } else {
      return 5
    }
  }

  const getMaxIndexNumber = () => {
    if (props.isMobile) {
      return 3
    } else {
      return 4
    }
  }

  const toggleImageModal = () => {
    setShowGridModal(!showGridModal)
  }

  useEffect(() => {
    setReviewImages(props.review?.guest_review_images)
  }, [props.reviews])

  useEffect(() => {
    const timer = setTimeout(() => {
      setImagesLoading(false)
    }, 1500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      {imagesLoading && reviewImages?.length > 0 && (
        <div
          className={
            'bikephotos-grid-wrapper review-grid container medium' +
            ' image-length5'
          }
        >
          <div className={buildImageClassName1(0, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName1(1, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName1(2, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName1(3, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName1(4, 5)}>
            <Skeleton height="100%" />
          </div>
        </div>
      )}
      {!imagesLoading && reviewImages?.length > 0 && (
        <>
          <div
            className={
              'bikephotos-grid-wrapper review-grid container' +
              ' image-length' +
              reviewImages.length
            }
          >
            {reviewImages?.map((image, index) =>
              index < getMaxImgNumber() ? (
                <div
                  key={index}
                  className={buildImageClassName2(index, reviewImages.length)}
                  onClick={() => toggleImageModal()}
                >
                  <img src={handleHeicImageType(image.url, image.jpg_url)} alt="review-image"></img>
                  {index === getMaxIndexNumber() &&
                    reviewImages.length > getMaxImgNumber() && (
                      <div class="centered">
                        + {reviewImages.length - getMaxImgNumber()}
                      </div>
                    )}
                </div>
              ) : null
            )}
          </div>
          <ImageGridModal
            showGridModal={showGridModal}
            isMobile={props.isMobile}
            toggleModal={() => {
              setShowGridModal(!showGridModal)
            }}
            reviewImages={reviewImages}
          />
        </>
      )}
    </>
  )
}

export default ReviewImages
